module.exports = __webpack_public_path__ + "4b5c8589b4e88dbbce89ac3295fe7724.png";